import React, { useMemo, useState } from 'react';
import { Breadcrumb, BreadcrumbItem, Container, Row, Button, Form } from 'reactstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import cx from 'classnames';
import URI from 'urijs';
import { push as routerPush } from 'react-router-redux';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../../components/blog/Blog.module.scss';
import { BlogContext, BlogList } from '../../components/blog/list';
import BufferedInput from '../../components/form/field/buffered-input';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { useRef } from 'react';

export function BlogContainer(props) {
  const { dispatch } = props;
  const path = props.match.path;
  const query = useMemo(
    () => URI(props.location.search).search(true),
    [props.location.search]
  );
  const currentPage = isNaN(query.page) ? 1 : parseInt(query.page, 10);
  const [search, setSearch] = useState(query.search);

  useEffect(() => {
    setSearch(query.search);
  }, [query.search, setSearch]);

  const [results, setResults] = useState();
  const blogContext = useMemo(() => {
    return {
      filters: query,
      setResults
    };
  }, [query]);

  const submitTimeout = useRef();
  function handleSubmit(e) {
    clearTimeout(submitTimeout.current);
    if (e) {
      e.preventDefault();
    }

    dispatch(
      routerPush(
        URI('/blog')
          .search({
            search,
            tags: query.tags
          })
          .toString()
      )
    );
  }

  return (
    <Container fluid>
      <Container>
        <Row>
          <Breadcrumb>
            <LinkContainer exact to="/">
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to="/blog">
              <BreadcrumbItem>
                <Link to="/blog">
                  NABOR<sup>®</sup> Blog
                </Link>
              </BreadcrumbItem>
            </LinkContainer>
          </Breadcrumb>
        </Row>
      </Container>
      <Row fluid className={styles.SearchHeader}>
        <Container>
          <Form inline className={cx(BS.alignItemsStart)} action onSubmit={handleSubmit}>
            <BlockSearchField
              value={search}
              onChange={value => {
                setSearch(value);
                clearTimeout(submitTimeout.current);
                submitTimeout.current = setTimeout(() => {
                  dispatch(
                    routerPush(
                      URI('/blog')
                        .search({
                          search: value,
                          tags: query.tags
                        })
                        .toString()
                    )
                  );
                }, 500);
              }}
            />
          </Form>
        </Container>
      </Row>
      <Container className={cx(BS.pt3)}>
        <h2>
          NABOR<sup>®</sup> Blog
        </h2>
        <p className={cx(BS.colorBlack, BS.mb5)}>
          Read blog postings and commentary from the Naples Area Board of REALTORS
          <sup>®</sup>
        </p>
        <BlogContext.Provider value={blogContext}>
          <BlogList {...query} excerptOnly limit={10} page={currentPage} />
        </BlogContext.Provider>

        <div className={cx(BS.inputGroupGutter, BS.mb3, BS.mt3)}>
          <Button
            tag={Link}
            color="dark-blue"
            disabled={currentPage === 1}
            to={URI(path)
              .search({
                ...query,
                page: currentPage - 1
              })
              .toString()}
          >
            Previous Page
          </Button>
          <Button
            tag={Link}
            color="dark-blue"
            disabled={!results || !results.length}
            to={URI(path)
              .search({
                ...query,
                page: currentPage + 1
              })
              .toString()}
          >
            Next Page
          </Button>
        </div>
      </Container>
    </Container>
  );
}

export default connect()(withRouter(BlogContainer));

function BlockSearchField(props) {
  const value = props.value;
  return (
    <BufferedInput
      name="search"
      type="text"
      placeholder="Search"
      component={BufferedInput}
      showSubmit
      className={cx(BS.mr0)}
      submitClassName={cx(BS.ml2)}
      groupClassName={cx(BS.inputGroupGutter, BS.pb3, BS.mrSm2)}
      value={value}
      onChange={props.onChange}
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/Blog/Blog.js